import { Component, computed, inject, input } from '@angular/core';
import { SharedCommonModule } from '@shared/common.module';
import { Router, RouterLink } from '@angular/router';
import { EduIconComponent } from '@atoms/icon/icon.component';
import { pageMenuStyles } from './page-menu.variants';
import { MenuContent, MenuItemContent } from '../types';
import { MenuService } from '@shared/services/menu.service';

@Component({
  selector: 'edu-page-menu',
  templateUrl: './page-menu.component.html',
  imports: [SharedCommonModule, RouterLink, EduIconComponent],
})
export class EduPageMenuComponent {
  private menuService = inject(MenuService);
  router = inject(Router);

  menuContents = input<MenuContent[]>([]);

  renderedMenuItems = computed(() => this.menuService.flattenMenuContents(this.menuContents()));

  get styles() {
    return pageMenuStyles();
  }

  getClassesForMenuItem(item: MenuItemContent) {
    return pageMenuStyles({
      active: item.route
        ? this.router.isActive(item.route, {
            paths: 'subset',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored',
            ...item.isActiveMatchOptions,
          })
        : false,
    });
  }
}
